import { MarkerClusterer } from "@googlemaps/markerclusterer";

window.mapApiLoaded = false;

const mapStyle = [
  {
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161"
      }
    ]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#f5f5f5"
      }
    ]
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#bdbdbd"
      }
    ]
  },
  {
    featureType: "landscape",
    stylers: [
      {
        color: "#edf2f1"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "all",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#dadada"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#e2ecec"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161"
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e"
      }
    ]
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [
      {
        color: "#e5e5e5"
      }
    ]
  },
  {
    featureType: "transit.station",
    elementType: "geometry",
    stylers: [
      {
        color: "#eeeeee"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#c9c9c9"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#a1bdc8"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e"
      }
    ]
  }
];

let map = null;
let markers = [];
let markerClusterer = null;
let image;
let imageActive;

const mapDiv = document.querySelector('.map');
const gmapDiv = mapDiv.querySelector('.google-map');
const placeInfo = mapDiv.querySelector('.place-info');
const baseUrl = 'https://www.alltombostad.se';


function showPlaceInfo(place) {
  const placeLogoWrap = placeInfo.querySelector('.place-info__logo');
  const placeLogo = placeLogoWrap.querySelector('img');
  const placelink = placeInfo.querySelector('.place-info__name a');
  const placeContacts = placeInfo.querySelector('.place-info .contacts');
  const placeLocation = placeContacts.querySelector('.contacts__location span');
  const placeTel = placeContacts.querySelector('.contacts__phone a');
  const placeTimeLi = placeContacts.querySelector('.contacts__time');
  const placeTime = placeTimeLi.querySelector('span');

  placeLogoWrap.style.display = place[5] ? 'block' : 'none';
  placeLogo.src = baseUrl + place[5];
  placelink.href = place[4];
  placelink.innerHTML = place[3];
  placeLocation.innerHTML = place[7];
  placeTel.href = `tel:${place[6]}`;
  placeTel.innerHTML = place[6];
  placeTimeLi.style.display = place[8] ? 'block' : 'none';
  placeTime.innerHTML = place[8];
  placeInfo.style.display = 'block';
}

function hidePlaceInfo() {
  placeInfo.style.display = 'none';
}

function resetActiveMarker() {
  for (var j = 0; j < markers.length; j++) {
    markers[j].setIcon(image);
  }
}

function setMarkers(map, places) {
  const bounds = new google.maps.LatLngBounds();

  markers = places.map((el, i) => {
    const position = {
      lat: el[1],
      lng: el[2],
    };
    const marker = new google.maps.Marker({
      map,
      position,
      title: el[3],
      icon: image,
    });

    marker.addListener('click', () => {
      if (!placeInfo) return;
      resetActiveMarker();
      marker.setIcon(imageActive);
      map.panTo(position);

      showPlaceInfo(el);
    });

    bounds.extend(position);

    return marker;
  });

  const render = ({ count, position }) => {
    return new google.maps.Marker({
      position,
      icon: {
        url: 'images/map-cluster.png',
        scaledSize: new google.maps.Size(40, 40),
      },
      label: {
        text: String(count),
        color: '#fff',
        fontWeight: '700',
        fontSize: '14px',
      },
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    });
  };

  markerClusterer = new MarkerClusterer({
    map,
    markers,
    renderer: { render },
  });

  map.setCenter(bounds.getCenter());

  if (places.length > 1) {
    map.fitBounds(bounds, 10);
  }
}

function loadMapData() {
  const url = gmapDiv.getAttribute('data-json');
  const urlParams = gmapDiv.getAttribute('data-filters');

  function resetMarkers() {
    if (markers.length === 0) return;

    if (markerClusterer) markerClusterer.clearMarkers();
    markers.forEach((el) => {
      el.setMap(null);
    });

    markers = [];
  }

  image = {
    url: 'images/map-marker.png',
    size: new google.maps.Size(46, 66),
    scaledSize: new google.maps.Size(23, 33),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(11, 29),
  };

  imageActive = {
    url: 'images/map-marker-active.png',
    size: new google.maps.Size(64, 90),
    scaledSize: new google.maps.Size(32, 45),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(16, 40),
  };

  if (url) {
    $.getJSON(url + urlParams, function (data) {
      resetMarkers();
      setMarkers(map, data);
    });
  } else if (localDealersArray && localDealersArray.length) {
    resetMarkers();
    setMarkers(map, localDealersArray);
  }
}

function initMap() {
  const zoom = Number(gmapDiv.getAttribute('data-zoom')) || 10;
  const mapProps = {
    zoom,
    center: new google.maps.LatLng(59.3261419, 17.4217127),
    styles: mapStyle,
    controlSize: 32,
    zoomControl: true,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    gestureHandling: 'cooperative',
  };

  map = new google.maps.Map(document.getElementById('googleMap'), mapProps);

  map.addListener("click", () => {
    if (!placeInfo) return;
    if (markers.length === 0) return;
    resetActiveMarker();
    hidePlaceInfo();
  });

  loadMapData();

  gmapDiv.map = map;
  window.mapApiLoaded = true;
}

window.initMap = initMap;
window.loadMapData = loadMapData;
